<template>
    <div id="layout">
        <layout-left />
        <div
            class="layout-content"
            :class="{active:isCollapse}"
        >
            <!-- <layout-right-top /> -->
            <layout-main />
        </div>
    </div>
</template>
<style scoped>
#nucarf-saas-head-wrap {
    height: 60px;
}
#layout {
    flex: 1;
    display: flex;
}
.layout-content {
    flex: 1;

    height: 100%;
    margin-left: 200px;
    transition: all 0.5s;
    display: flex;
}
.layout-content.active {
    margin-left: 65px;
}
</style>

<script>
import LayoutLeft from './components/LayoutLeft'
import LayoutMain from './components/LayoutMain'

export default {
    components: {
        LayoutLeft,
        LayoutMain,
    },
    computed: {
        isCollapse () {
            return this.$store.state.Layout.isCollapse;
        }
    },
    methods: {

    }
}
</script>